import {
  CLEAR_FILES_LIST,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  SET_FILES_LIST,
  UPLOAD_FILE,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_PROGRESS,
  UPLOAD_FILE_SUCCESS,
  DOWNLOAD_ALL_FILES,
  UPLOAD_ENTITY_FILE_SUCCESS,
  STOP_UPLOAD_FILE,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';

// Handles beginning of the file uploading
export const uploadFile = (file, payload = {}) => {
  return {
    type: UPLOAD_FILE,
    payload: {
      file,
      ...payload,
    },
  };
};

// Handles file uploading progress change
export const uploadProgress = (file, progress) => {
  return {
    type: UPLOAD_FILE_PROGRESS,
    payload: progress,
    meta: { file },
  };
};

export const stopUpload = () => {
  return {
    type: STOP_UPLOAD_FILE,
  };
};

// Handles file uploading failure
export const uploadFailure = (file, error) => {
  return {
    type: UPLOAD_FILE_FAILURE,
    payload: error,
    meta: { file },
  };
};

// Handles file uploading success
export const uploadSuccess = (file, response) => {
  return {
    type: UPLOAD_FILE_SUCCESS,
    payload: response,
    meta: file,
  };
};

// Handles file uploading whithout form success
export const uploadWhithoutFormSuccess = (response) => {
  return {
    type: UPLOAD_ENTITY_FILE_SUCCESS,
    response,
  };
};

// Handles successfully file deletion.
export const deleteFile = (fileId, entity, entityId, projectId = null, file = null) => {
  return {
    type: DELETE_FILE,
    payload: {
      resource: 'files',
      entityId: fileId,
      onSuccess: (id) => deleteFileSuccess(id, entity, entityId, projectId, file),
      onErrorFunction: () => {}, // Перекрываем показ ошибки во весь экран
      onErrorMessage: getIntlMessage('file.delete.error'),
    },
  };
};
const deleteFileSuccess = (fileId, entity, entityId, file) => {
  return {
    type: DELETE_FILE_SUCCESS,
    fileId,
    entity,
    entityId,
    file,
  };
};

// Handles clearing of the files list
export const clearFilesList = () => {
  return {
    type: CLEAR_FILES_LIST,
  };
};

// Handles setting of the files list
export const setFilesList = (filesList) => {
  return {
    type: SET_FILES_LIST,
    payload: filesList,
  };
};

// Handles file downloading
export const downloadFile = (file) => {
  return {
    type: DOWNLOAD_FILE,
    payload: {
      resource: 'files/' + file.fileId,
      onErrorMessage: getIntlMessage('request.error'),
      onSuccess: (blobFile) => downloadFileSuccess(blobFile, { name: file.name, extension: file.extension }),
    },
  };
};

// Handles file downloading
export const downloadAllFiles = (entityInfo) => {
  return {
    type: DOWNLOAD_ALL_FILES,
    payload: {
      resource: 'files/' + entityInfo.entityId,
      onErrorMessage: getIntlMessage('request.error'),
      onSuccess: (blobFile) => downloadFileSuccess(blobFile, { name: 'files', extension: 'zip' }),
      entity: entityInfo.entity,
    },
  };
};

export const downloadFileSuccess = (blobFile, payload = {}) => {
  return {
    type: DOWNLOAD_FILE_SUCCESS,
    payload: {
      name: 'file',
      extension: 'txt',
      file: blobFile,
      ...payload,
    },
  };
};
